import * as Yup from 'yup'

export const editProfileSchema = (profileData: any) => {
  const data = {
    // name: "",
    // zipcode: ""
    name: `${profileData?.hero_name}`,
    phone: profileData?.phone_number || "",
    email: profileData?.email || "",
    zipcode: `${profileData?.zip_code}`
  }
  return data
}


export const profileValidater = () => Yup.object().shape({
  name: Yup.string().trim().required('Please enter your name').max(30, "Name must be maximum 30 characters").min(3, "Name must be minimum 3 characters "),
  zipcode: Yup.string().trim().required('Please enter Zipcode')
})
